// Per-page SEO copy. The home page values must match the defaults in
// public/index.html, which is all that social link previews ever read.
export const SITE = {
  name: "Vinayaka Matrimony",
  url: "https://www.vinayakamatrimony.com",
  image: "https://www.vinayakamatrimony.com/og-image.jpg",
};

export const PAGES = {
  home: {
    path: "/",
    title: "Kerala Matrimony | Vinayaka Matrimony - Verified Profiles",
    description:
      "Trusted Kerala matrimony by Vinayaka Foundation, Kannur. Genuinely verified profiles and mobile numbers. Register free and find your life partner today.",
  },
  register: {
    path: "/register",
    title: "Register Free | Vinayaka Matrimony",
    description:
      "Join Vinayaka Matrimony for free. Create your profile in a minute and connect with genuinely verified profiles from Kerala families.",
  },
  login: {
    path: "/login",
    title: "Login and find your life partner | Vinayaka Matrimony",
    description:
      "Log in to Vinayaka Matrimony with your VNK ID or email address to search matches, view profiles and manage your account.",
  },
  premium: {
    path: "/premium",
    title: "Premium Membership Plans | Vinayaka Matrimony",
    description:
      "Upgrade to Vinayaka Matrimony premium for 6 months (Rs 600) or 12 months (Rs 1200) and view contact details of verified profiles.",
  },
  account: {
    path: "/account",
    title: "My Account | Vinayaka Matrimony",
    description: "Manage your Vinayaka Matrimony profile, photos, searches and interests.",
    noindex: true,
  },
};
